import React from 'react'
import Img from 'gatsby-image'
import ReactPlayer from 'react-player'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'

import styles from './styles'
import ErrorBoundary from '../error'

class BackgroundVideo extends React.Component {
  state = {
    isIOS: false,
  }

  componentDidMount() {
    this.setState({
      isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent),
    })

    this.player.getInternalPlayer().style['object-fit'] = 'cover'
  }

  render() {
    const { classes, urls, poster } = this.props
    const { isIOS } = this.state

    return (
      <ErrorBoundary>
        <ReactPlayer
          ref={p => (this.player = p)}
          url={isIOS ? urls[1].src : urls[0].src}
          style={{ objectFit: 'cover' }}
          width={'100%'}
          height={'100%'}
          loop
          autoPlay
          playing
          muted
          playsinline
        />
      </ErrorBoundary>
    )

    // return !isIOS ? (
    //   <ReactPlayer
    //     ref={p => (this.player = p)}
    //     url={urls[0].src}
    //     style={{ objectFit: 'cover' }}
    //     width={'100%'}
    //     height={'100%'}
    //     loop
    //     autoPlay
    //     playing
    //     muted
    //   />
    // ) : (
    //   <div style={{
    //     backgroundImage: `url(${poster.url})`,
    //     height: '100vh',
    //     backgroundSize: 'cover'
    //   }}/>
    // )
  }
}

export default withStyles(styles)(BackgroundVideo)



// WEBPACK FOOTER //
// ./src/components/video/background.js